import { lazy } from 'react';

import { SocialMediaIcons } from 'templates/components/BannerCarousel/types';

const IconFacebookColored = lazy(() =>
  import('@picsart/design-system/foundation/icons/IconFacebookColored').then(module => ({
    default: module.IconFacebookColored,
  })),
);
const IconTikTokColored = lazy(() =>
  import('@picsart/design-system/foundation/icons/IconTikTokColored').then(module => ({
    default: module.IconTikTokColored,
  })),
);
const IconInstagramColored = lazy(() =>
  import('@picsart/design-system/foundation/icons/IconInstagramColored').then(module => ({
    default: module.IconInstagramColored,
  })),
);
const IconYouTubeColored = lazy(() =>
  import('@picsart/design-system/foundation/icons/IconYouTubeColored').then(module => ({
    default: module.IconYouTubeColored,
  })),
);
const IconTwitterColored = lazy(() =>
  import('@picsart/design-system/foundation/icons/IconTwitterColored').then(module => ({
    default: module.IconTwitterColored,
  })),
);
const IconLinkedInColored = lazy(() =>
  import('@picsart/design-system/foundation/icons/IconLinkedInColored').then(module => ({
    default: module.IconLinkedInColored,
  })),
);
const IconTwitchColored = lazy(() =>
  import('@picsart/design-system/foundation/icons/IconTwitchColored').then(module => ({
    default: module.IconTwitchColored,
  })),
);
const IconPinterestColored = lazy(() =>
  import('@picsart/design-system/foundation/icons/IconPinterestColored').then(module => ({
    default: module.IconPinterestColored,
  })),
);
const IconSnapChatColored = lazy(() =>
  import('@picsart/design-system/foundation/icons/IconSnapChatColored').then(module => ({
    default: module.IconSnapChatColored,
  })),
);
const IconSpotifyColored = lazy(() =>
  import('@picsart/design-system/foundation/icons/IconSpotifyColored').then(module => ({
    default: module.IconSpotifyColored,
  })),
);

export const socialMediaIconsMap = {
  [SocialMediaIcons.Facebook]: <IconFacebookColored />,
  [SocialMediaIcons.Instagram]: <IconInstagramColored />,
  [SocialMediaIcons.YouTube]: <IconYouTubeColored />,
  [SocialMediaIcons.Twitter]: <IconTwitterColored />,
  [SocialMediaIcons.LinkedIn]: <IconLinkedInColored />,
  [SocialMediaIcons.Twitch]: <IconTwitchColored />,
  [SocialMediaIcons.Pinterest]: <IconPinterestColored />,
  [SocialMediaIcons.TikTok]: <IconTikTokColored />,
  [SocialMediaIcons.SnapChat]: <IconSnapChatColored />,
  [SocialMediaIcons.Spotify]: <IconSpotifyColored />,
};
